import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${article.slug}`}
      className="group block bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300"
    >
      <div className="relative w-full aspect-[16/9] overflow-hidden">
        <img
          src={article.coverImage}
          alt={article.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-3 left-3">
          <Link
            to={`/category/${article.categorySlug}`}
            className="inline-block px-2.5 py-1 rounded-full text-xs font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors"
            onClick={(e) => e.stopPropagation()}
          >
            {article.category}
          </Link>
        </div>
      </div>
      <div className="p-4 md:p-5">
        <h3 className="font-heading text-base md:text-lg text-foreground-950 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
          {article.title}
        </h3>
        <p className="text-foreground-600 text-sm leading-relaxed line-clamp-2 mb-3">
          {article.excerpt}
        </p>
        <div className="flex items-center gap-3 text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-user-line"></i>
            {article.author}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line"></i>
            {article.readTime}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {article.publishedAt}
          </span>
        </div>
      </div>
    </Link>
  );
}